import { create } from 'zustand';

const getSavedDensity = () => {
  try {
    if (typeof window === 'undefined') return 'comfortable';
    const saved = window.localStorage.getItem('ui.tableDensity');
    return saved === 'compact' ? 'compact' : 'comfortable';
  } catch {
    return 'comfortable';
  }
};

export const useUIStore = create((set) => ({
  isSidebarOpen: true,
  tableDensity: getSavedDensity(),
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (open) => set({ isSidebarOpen: open }),
  setTableDensity: (density) => {
    const next = density === 'compact' ? 'compact' : 'comfortable';
    try {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('ui.tableDensity', next);
      }
    } catch {
      void 0;
    }
    set({ tableDensity: next });
  },
}));
